import { Box, Flex } from "@highoutput/ui-components";
import type {
  AnnouncementQuery,
  FaqCoreDataFragment,
  PlanCoreDataFragment,
  PostsQuery,
  ServiceCoreDataFragment,
  TestimonialCoreDataFragment,
} from "~/__generated__/graphql";
import Navbar from "../navbar";
import Hero from "./hero";
import Announcement from "./v2/announcement";
import Blog from "./v2/blog";
import Events from "./v2/events";
import Faqs from "./v2/faq";
import Footer from "./v2/footer";
import FreeCoachingSection from "./v2/free-coaching";
import HowItWorks from "./v2/how-it-works";
import Offer from "./v2/offer";
import Partners from "./v2/partners/indext";
import Services from "./v2/services";
import Testimonials from "./v2/testimonial";

type AboutProps = {
  data: {
    faqs: FaqCoreDataFragment[];
    plans: PlanCoreDataFragment[];
    posts: NonNullable<PostsQuery["posts"]>["data"];
    services: ServiceCoreDataFragment[];
    testimonials: TestimonialCoreDataFragment[];
    announcement: AnnouncementQuery["announcement"];
  };
};

export default function Landing({ data }: AboutProps) {
  const { faqs, posts, testimonials, announcement } = Object.assign(
    {
      faqs: [],
      plans: [],
      posts: [],
      services: [],
      testimonials: [],
      announcement: [],
    },
    data,
  );

  return (
    <Flex direction="column" minHeight="100vh" minWidth={"375px"}>
      <Announcement data={announcement} />
      <Navbar />

      <Box as="main" flexGrow={1}>
        <Hero />
        <Partners />
        {/* <Services data={services} /> */}
        <Services />
        <FreeCoachingSection />
        {/* <FreeCoachingSection /> */}
        <Testimonials data={testimonials} />
        {/* <Pricing /> */}

        <Blog data={posts} />
        <Offer />
        <HowItWorks />

        <Events />
        <Faqs data={faqs} />
      </Box>

      <Footer cta />
    </Flex>
  );
}
